export default {
  "loyaltyAdmin.workspaceAccessRequired": "Your account can view this merchant, but has no loyalty access for it. Ask an administrator to assign a loyalty role for this merchant or its owner, then sign in again. Payment and financial permissions are separate.",
  "loyaltyAdmin.sourceTitle": "Loyalty source and Syrve",
  "loyaltyAdmin.sourceScope": "Changes apply only to the selected merchant.",
  "loyaltyAdmin.sourcePurpose": "These settings choose whether payments use Syrve or Coop loyalty. They are not required to create a category or issue a card.",
  "loyaltyAdmin.sourceChangeSettings": "Change the payment loyalty system",
  "loyaltyAdmin.sourceFinancial": "Financial loyalty source",
  "loyaltyAdmin.sourceSyrveIntegration": "Syrve loyalty integration",
  "loyaltyAdmin.sourceNative": "Coop native loyalty",
  "loyaltyAdmin.sourceSyrve": "Syrve",
  "loyaltyAdmin.sourceEnabled": "Enabled",
  "loyaltyAdmin.sourceDisabled": "Disabled",
  "loyaltyAdmin.sourceSeparateNotice": "Selecting a source does not disable Syrve integration.",
  "loyaltyAdmin.sourceAction": "Setting to change",
  "loyaltyAdmin.sourceTarget": "New financial source",
  "loyaltyAdmin.sourceIntegrationTarget": "New Syrve integration state",
  "loyaltyAdmin.sourceReason": "Reason for source or integration change",
  "loyaltyAdmin.sourceReconciliation": "Reconciliation and readiness confirmation",
  "loyaltyAdmin.sourceRollback": "Rollback plan",
  "loyaltyAdmin.sourceConsequences": "Before changing, stop new loyalty operations, finish active visits and reconcile outstanding payments and balances. Existing balances and operation history remain unchanged. Other POS functions are unaffected.",
  "loyaltyAdmin.sourceApply": "Apply this administrative change",
  "loyaltyAdmin.sourceRetry": "Retry saved administrative change",
  "loyaltyAdmin.sourceApplied": "Administrative change confirmed and recorded.",
  "loyaltyAdmin.sourcePendingWork": "The current setting is preserved. Finish active visits and reconcile pending payments or loyalty operations before changing it.",
  "loyaltyAdmin.sourceNativeUnavailable": "Native checkout is not ready for the configured POS routes. The current source is preserved.",
  "loyaltyAdmin.sourceAdapterRequired": "Enable the Syrve loyalty integration in a separate action before selecting Syrve as financial source.",
  "loyaltyAdmin.sourceRevisionChanged": "The settings changed. Refresh them and review the requested change again.",
  "loyaltyAdmin.sourceResultUnknown": "The result is unconfirmed. Retry the same saved command before starting another change.",
  "loyaltyAdmin.sourceEditRejected": "Review rejected change",
  "loyaltyAdmin.sourceInvalidSaved": "Saved administrative change cannot be recovered. Contact an administrator to verify its result.",
  "loyaltyAdmin.giftFundingTitle": "Paid Gift card",
  "loyaltyAdmin.giftFundingNotice": "Choose an unpaid Gift invoice, collect payment, then check the result.",
  "loyaltyAdmin.giftFundingDisabled": "Paid Gift funding is unavailable for this merchant.",
  "loyaltyAdmin.giftFundingKind": "Gift operation",
  "loyaltyAdmin.giftSale": "Issue after payment",
  "loyaltyAdmin.giftTopup": "Paid top-up",
  "loyaltyAdmin.giftInvoice": "Gift funding invoice",
  "loyaltyAdmin.giftSelectInvoice": "Select an unpaid invoice",
  "loyaltyAdmin.giftUnnumberedInvoice": "Invoice without number",
  "loyaltyAdmin.giftSavedInvoice": "Previously selected invoice",
  "loyaltyAdmin.giftRefreshInvoices": "Refresh invoices",
  "loyaltyAdmin.giftNoInvoices": "No eligible unpaid invoice. Create a separate invoice for the Gift value in the usual order flow.",
  "loyaltyAdmin.giftReason": "Reason for Gift funding",
  "loyaltyAdmin.giftPrepare": "Prepare Gift payment",
  "loyaltyAdmin.giftRetryPreparation": "Retry the same preparation",
  "loyaltyAdmin.giftAwaitingPayment": "Waiting for full payment and its issued receipt:",
  "loyaltyAdmin.giftRefreshResult": "Check payment and Gift result",
  "loyaltyAdmin.giftCancelNotice": "Preparation can be canceled only when the server confirms that payment has not started. An unknown bank result remains pending.",
  "loyaltyAdmin.giftCancelReason": "Reason to stop preparation",
  "loyaltyAdmin.giftCancelPreparation": "Stop preparation if payment has not started",
  "loyaltyAdmin.giftCanceled": "Preparation canceled. No Gift value was added.",
  "loyaltyAdmin.giftCanceling": "Cancellation is being verified. Keep this attempt until its result is confirmed.",
  "loyaltyAdmin.giftCompleted": "Gift value added:",
  "loyaltyAdmin.reservedValue": "Reserved value",
  "loyaltyAdmin.giftAvailable": "Available value:",
  "loyaltyAdmin.giftValueExpires": "This purchased value expires:",
  "loyaltyAdmin.giftNext": "Start another Gift operation",
  "loyaltyAdmin.giftRecoverNotice": "The saved attempt could not be read. Retry the same preparation or check its result; do not collect payment again.",
  "loyaltyAdmin.giftOperationPending": "The result is unconfirmed. Keep this attempt and check again. For a top-up retry, present the same card code again.",
  "loyaltyAdmin.giftInvalidRecovery": "Saved Gift recovery data cannot be read safely. Contact an administrator to check the existing operation before starting another one.",
  "loyaltyAdmin.gift": "Gift card",
  "loyaltyAdmin.giftMonths": "Purchased value lifetime, months",
  "loyaltyAdmin.giftPaidOnly": "Issued empty. Add Gift value separately.",
  "loyaltyAdmin.creditGiftAmount": "Gift amount to credit",
  "loyaltyAdmin.manualGiftCredit": "Credit Gift value",
  "loyaltyAdmin.giftCredited": "Gift value credited",
  "loyaltyAdmin.manualGiftNotice": "Manual credit without payment.",

  "loyaltyAdmin.systemAuthor": "System",
  "loyaltyAdmin.workspaceIntro": "Gift, accumulation and discount cards",
  "loyaltyAdmin.sessionChanged": "Session changed. Reload the page before continuing.",
  "loyaltyAdmin.ownerChanged": "Merchant ownership changed. Reload and check the current program before continuing.",
  "loyaltyAdmin.cardQr": "Loyalty card QR code",
  "loyaltyAdmin.downloadCardQr": "Save card QR",
  "loyaltyAdmin.findCard": "Find card",
  "loyaltyAdmin.cardCode": "Exact card code",
  "loyaltyAdmin.exactCodeNotice": "Scan or enter the full card code.",
  "loyaltyAdmin.scanCard": "Scan card",
  "loyaltyAdmin.closeCamera": "Close camera",
  "loyaltyAdmin.cameraStarting": "Starting camera…",
  "loyaltyAdmin.cameraUnavailable": "Camera unavailable. Allow camera access or enter the code manually.",
  "loyaltyAdmin.cardLookupFailed": "Card not found or unavailable. Check the merchant and exact code.",
  "loyaltyAdmin.recoveryUnavailable": "Credit operations are currently disabled. Keep the saved request for reconciliation.",
  "loyaltyAdmin.invalidRecovery": "The saved request cannot be read safely. New credits are blocked until its actual outcome is reconciled.",
  "loyaltyAdmin.coreFinanceTitle": "Native card finances",
  "loyaltyAdmin.issuerOnlyNotice": "Only cards issued by this merchant are listed here.",
  "loyaltyAdmin.checkResult": "Check saved result",
  "loyaltyAdmin.cancelPendingCredit": "Cancel unposted credit",
  "loyaltyAdmin.retryCancel": "Retry cancellation",
  "loyaltyAdmin.cancelledCredit": "The credit was cancelled; no points were added.",
  "loyaltyAdmin.committedAwaitingCore": "The credit was posted. Core reconciliation is still pending; retain the original request.",
  "loyaltyAdmin.abortedAwaitingCore": "Cancellation is recorded. Core reconciliation is still pending.",
  "loyaltyAdmin.pendingCredit": "The operation is still pending. No new request has been created.",
  "loyaltyAdmin.financeUnavailable": "Financial information is temporarily unavailable. Retain and retry the saved request.",

  "loyaltyAdmin.title": "Loyalty cards",
  "loyaltyAdmin.notice":
    "These cards are not yet available for payments. Existing Syrve loyalty continues to work.",
  "loyaltyAdmin.merchant": "Merchant",
  "loyaltyAdmin.selectMerchant": "Select a merchant",
  "loyaltyAdmin.loadError": "Unable to load merchants.",
  "loyaltyAdmin.disabled":
    "Native loyalty administration is not enabled for this environment.",
  "loyaltyAdmin.forbidden": "You do not have access to this operation.",
  "loyaltyAdmin.changed":
    "The record changed. Refresh and review it before trying again.",
  "loyaltyAdmin.conflict": "This request key belongs to another operation.",
  "loyaltyAdmin.requestError":
    "Request failed. Refresh or retry the saved request.",
  "loyaltyAdmin.storageRequired":
    "Allow session storage to retain a safe retry receipt before continuing.",
  "loyaltyAdmin.invalid":
    "Check the percentages, point value and expiry period.",
  "loyaltyAdmin.refresh": "Refresh",
  "loyaltyAdmin.uncertain":
    "The result is unconfirmed. Retry the same request to avoid a duplicate.",
  "loyaltyAdmin.retry": "Retry saved request",
  "loyaltyAdmin.issued": "Card issued",
  "loyaltyAdmin.bearerWarning":
    "Keep this number safe: in bearer mode it grants the right to spend. Do not publish it.",
  "loyaltyAdmin.hide": "Hide number",
  "loyaltyAdmin.categories": "Categories",
  "loyaltyAdmin.version": "Version",
  "loyaltyAdmin.edit": "Edit",
  "loyaltyAdmin.history": "Rule history",
  "loyaltyAdmin.reason": "Reason for change or issue",
  "loyaltyAdmin.issueReason": "Reason for card issue",
  "loyaltyAdmin.companionCategory": "Second category (optional)",
  "loyaltyAdmin.singleCategory": "No second category",
  "loyaltyAdmin.blockReason": "Reason for blocking or unblocking",
  "loyaltyAdmin.newVersion": "New rule version",
  "loyaltyAdmin.newCategory": "New category",
  "loyaltyAdmin.createCategory": "Create category",
  "loyaltyAdmin.resetCategory": "Reset category form",
  "loyaltyAdmin.reasonRequired": "A reason is required.",
  "loyaltyAdmin.versionNotice":
    "Issued cards keep their original rules.",
  "loyaltyAdmin.name": "Name",
  "loyaltyAdmin.kind": "Type",
  "loyaltyAdmin.accumulation": "Accumulation",
  "loyaltyAdmin.discount": "Discount",
  "loyaltyAdmin.rate": "Rate, %",
  "loyaltyAdmin.limit": "Redemption limit, %",
  "loyaltyAdmin.pointRate": "Value of 1 point",
  "loyaltyAdmin.months": "Credit lifetime, months",
  "loyaltyAdmin.confirmation": "Spend confirmation",
  "loyaltyAdmin.BEARER": "Bearer",
  "loyaltyAdmin.PIN": "PIN",
  "loyaltyAdmin.SMS": "SMS",
  "loyaltyAdmin.ACCOUNT": "Guest account",
  "loyaltyAdmin.DYNAMIC_QR": "One-time QR",
  "loyaltyAdmin.excludeAccrual": "No accrual for",
  "loyaltyAdmin.excludeDiscount": "No discount for",
  "loyaltyAdmin.excludeRedemption": "No redemption for",
  "loyaltyAdmin.removedCategory": "Removed product category — review exclusion",
  "loyaltyAdmin.save": "Save version",
  "loyaltyAdmin.issue": "Issue card",
  "loyaltyAdmin.category": "Category",
  "loyaltyAdmin.selectCategory": "Select a category",
  "loyaltyAdmin.more": "Load more",
  "loyaltyAdmin.cards": "Cards",
  "loyaltyAdmin.blocked": "Blocked",
  "loyaltyAdmin.active": "Active",
  "loyaltyAdmin.unblock": "Unblock",
  "loyaltyAdmin.block": "Block",
  "loyaltyAdmin.financeTitle": "Coop balance and operations",
  "loyaltyAdmin.selectCard": "Select a card",
  "loyaltyAdmin.pendingCard": "Card with a pending request",
  "loyaltyAdmin.balance": "Balance",
  "loyaltyAdmin.available": "Available points",
  "loyaltyAdmin.reserved": "Reserved points",
  "loyaltyAdmin.creditPoints": "Points to credit",
  "loyaltyAdmin.expiryOverride": "Override expiry date",
  "loyaltyAdmin.expiryHint": "Blank uses the card term. A selected date ends at 23:59 UTC",
  "loyaltyAdmin.monthsUnit": "months",
  "loyaltyAdmin.overrideReason": "Reason for changing expiry",
  "loyaltyAdmin.manualCredit": "Credit points",
  "loyaltyAdmin.operations": "Operations",
  "loyaltyAdmin.author": "Author",
  "loyaltyAdmin.standardExpiry": "Standard expiry",
  "loyaltyAdmin.selectedExpiry": "Selected expiry",
  "loyaltyAdmin.credited": "Points credited",
  "loyaltyAdmin.creditReceiptTitle": "Confirmed credit",
  "loyaltyAdmin.newBalance": "New balance",
  "loyaltyAdmin.minorUnits": "minor units",
  "loyaltyAdmin.creditReceiptUnavailable": "The credit is confirmed, but some exact receipt details could not be loaded. Missing balance or expiry values are not inferred.",
  "loyaltyAdmin.retryReceipt": "Load receipt details",
  "loyaltyAdmin.financeRecovery": "The request outcome is uncertain. Retry this request before starting another credit.",
  "loyaltyAdmin.financeChanged": "The balance changed. Refresh and review the amount.",
  "loyaltyAdmin.financeValidation": "Enter a positive amount matching the point rate, a reason, and a future expiry date with an override reason.",
  "loyaltyAdmin.pointsUnit": "points",
  "loyaltyAdmin.refreshBalance": "Refresh balance",
  "loyaltyAdmin.operationCREDIT": "Accrual",
  "loyaltyAdmin.operationRESERVE": "Reservation",
  "loyaltyAdmin.operationCOMMIT": "Redemption",
  "loyaltyAdmin.operationRELEASE": "Release",
  "loyaltyAdmin.operationREVERSE_CREDIT": "Accrual reversal",
  "loyaltyAdmin.operationREFUND_SPEND": "Redemption refund",
  "loyaltyAdmin.operationEXPIRE": "Expiry",
  "loyaltyAdmin.coreCategoriesTitle": "Core loyalty categories",
  "loyaltyAdmin.categoryReadOnlyNotice": "Read-only view. Category changes and card issuance through Core are not available yet.",
  "loyaltyAdmin.issuerCategoryNotice": "Only categories issued by this merchant are listed here.",
  "loyaltyAdmin.currency": "Currency",
  "loyaltyAdmin.giftKind": "Gift card",
  "loyaltyAdmin.accrualRate": "Accrual, %",
  "loyaltyAdmin.discountRate": "Discount, %",
  "loyaltyAdmin.giftLifetime": "Gift value lifetime, months",
  "loyaltyAdmin.notConfigured": "Requires configuration review",
  "loyaltyAdmin.exclusionReferenceNotice": "Exclusion counts are shown; product-category names require catalog reconciliation.",
  "loyaltyAdmin.moreHistory": "Load older versions",
  "loyaltyAdmin.transferTitle": "Card list import",
  "loyaltyAdmin.transferExportPairedUnavailable": "Export is unavailable while this owner has cards with two categories. The current file format would omit the second category and balance.",
  "loyaltyAdmin.transferExportTitle": "Live card and balance export",
  "loyaltyAdmin.transferExportNotice": "Creates a financial-access snapshot with exact available card codes, every category version and balance lot, separate Gift and promo obligations, and merchant credit/redemption activity. Export stops if an exact code or pending balance cannot be proved.",
  "loyaltyAdmin.transferExportXlsx": "Export live XLSX",
  "loyaltyAdmin.transferExportCsv": "Export live CSV",
  "loyaltyAdmin.transferExportPreparing": "Preparing the owner snapshot…",
  "loyaltyAdmin.transferExportReady": "The verified snapshot has been downloaded.",
  "loyaltyAdmin.transferNotice": "Preview only. Cards and balances are unchanged; confirmed import is not available yet.",
  "loyaltyAdmin.transferTemplateNotice": "Download and fill the template. Replace every example code, balance, snapshot date and category rule with your data.",
  "loyaltyAdmin.transferTemplateXlsx": "XLSX template",
  "loyaltyAdmin.transferTemplateCsv": "CSV template (ZIP)",
  "loyaltyAdmin.transferFormat": "File format",
  "loyaltyAdmin.transferFileLimit": "Up to 2 MB in total. CSV requires all three files, including a header-only lots table when there are no lots.",
  "loyaltyAdmin.transferCheck": "Check files",
  "loyaltyAdmin.transferSave": "Save package",
  "loyaltyAdmin.transferOpeningCheck": "Check opening balances",
  "loyaltyAdmin.transferOpeningChecked": "Opening calculations checked",
  "loyaltyAdmin.transferOpeningBlocked": "Opening calculations blocked",
  "loyaltyAdmin.transferOpeningAt": "Calculation time",
  "loyaltyAdmin.transferOpeningNotice": "Calculation only. Mappings, source identity acceptance, expiry agreements and confirmed journal application are still required. No cards or balances have changed.",
  "loyaltyAdmin.transferOpeningSource": "Snapshot balance, minor units",
  "loyaltyAdmin.transferOpeningExpired": "Expired since snapshot, minor units",
  "loyaltyAdmin.transferOpeningProjected": "Projected balance, minor units",
  "loyaltyAdmin.transferFutureSnapshot": "Snapshot date is in the future. Verify the original timestamp.",
  "loyaltyAdmin.transferSaveNotice": "Save an encrypted source snapshot for later reconciliation. This does not create cards, confirm import or change balances.",
  "loyaltyAdmin.transferSaved": "Package saved; import has not been applied. Reference",
  "loyaltyAdmin.transferDraftConflict": "This save request already refers to different data. Check the files again before creating a new package.",
  "loyaltyAdmin.transferValid": "File check passed",
  "loyaltyAdmin.transferInvalid": "Check the files and destination currency.",
  "loyaltyAdmin.transferErrors": "Errors",
  "loyaltyAdmin.transferWarnings": "Checks required before import",
  "loyaltyAdmin.transferMinorBalance": "Balance (minor currency units)",
  "loyaltyAdmin.transferSection_cards": "Cards",
  "loyaltyAdmin.transferSection_categories": "Category versions",
  "loyaltyAdmin.transferSection_lots": "Lots",
  "loyaltyAdmin.transferSection_package": "Package",
  "loyaltyAdmin.transferRow": "Row",
  "loyaltyAdmin.transferDuplicate": "Duplicate card, code, category version or lot.",
  "loyaltyAdmin.transferBalanceMismatch": "Lot totals and debt do not match the balance.",
  "loyaltyAdmin.transferMapping": "Confirm the card/category destination and version before import.",
  "loyaltyAdmin.transferOpening": "Confirm the opening balance and expiry policy.",
  "loyaltyAdmin.transferReservations": "Reconcile unfinished reservations before import.",
  "loyaltyAdmin.transferGift": "Gift value application is not available yet.",
  "loyaltyAdmin.transferCheckRow": "Check row fields, types and original timestamps.",
  "loyaltyAdmin.transferFile_cards": "Cards CSV",
  "loyaltyAdmin.transferFile_categories": "Category versions CSV",
  "loyaltyAdmin.transferFile_lots": "Lots CSV",
  "loyaltyAdmin.transferFile_workbook": "XLSX workbook",
  "loyaltyAdmin.transferSessionChanged": "Session changed. Reload this page and select the files again.",
  "loyaltyAdmin.transferApplyTitle": "Confirm import",
  "loyaltyAdmin.transferApplyNotice": "Creates Coop cards and observed opening balances, including Gift value with known original lots and expiry. Syrve and the financial source remain unchanged. Unknown expiry, reservations and product category mappings require reconciliation.",
  "loyaltyAdmin.transferApplyPending": "Recover previous request",
  "loyaltyAdmin.transferApplyIssuer": "All source cards have one issuer; assign them to the selected issuing merchant.",
  "loyaltyAdmin.transferApplyBalances": "I checked the balances, debt and original expiry dates.",
  "loyaltyAdmin.transferApply": "Import",
  "loyaltyAdmin.transferApplyRetry": "Retry original import",
  "loyaltyAdmin.transferApplyCancel": "Cancel uncommitted import",
  "loyaltyAdmin.transferApplied": "Cards imported",
  "loyaltyAdmin.transferApplyAborted": "Import cancelled without creating balances.",
  "loyaltyAdmin.transferApplyLookup": "Find imported cards",
  "loyaltyAdmin.transferApplyDone": "Finish",
  "loyaltyAdmin.transferApplyStorage": "Could not save recovery data. No new request was sent.",
  "loyaltyAdmin.transferApplyUnknown": "Result unknown. Retry the original request or cancel it. Cancellation reports a completed import without reversing balances.",
  "loyaltyAdmin.transferApplyMappingBlocked": "Reconcile issuer or product category mappings. Cancel this request before correcting the package.",
  "loyaltyAdmin.transferApplyConflict": "Source identity or card code already exists. Reconcile the original import without creating another balance.",
  "loyaltyAdmin.transferApplyUnsupported": "Reconcile rules, expiries, reservations or product categories before importing.",
  "loyaltyAdmin.operationIMPORT_OPENING": "Imported opening balance",
  "loyaltyAdmin.transferApplyCategoryLimit": "The destination supports up to 500 categories. Cancel this request and reconcile the package with existing categories.",
  "loyaltyAdmin.tasks": "Actions",
  "loyaltyAdmin.back": "Back",
  "loyaltyAdmin.taskfind": "Find card",
  "loyaltyAdmin.taskcatalog": "Card catalogue",
  "loyaltyAdmin.taskissue": "Issue empty card",
  "loyaltyAdmin.taskcategories": "Categories",
  "loyaltyAdmin.taskgift": "Sell / top up Gift",
  "loyaltyAdmin.tasksource": "Program settings",
  "loyaltyAdmin.openCard": "Open card",
  "loyaltyAdmin.loading": "Loading…",
  "loyaltyAdmin.balanceRead": "Balance updated",
  "loyaltyAdmin.balanceDetails": "Balance details",
  "loyaltyAdmin.creditUnavailable": "Manual credit is temporarily unavailable. Contact the program administrator.",
  "loyaltyAdmin.issuerRequired": "Manual credit is available at the issuing merchant.",
  "loyaltyAdmin.resumeCredit": "Resume saved credit",
  "loyaltyAdmin.checkoutpoints": "points",
  "loyaltyAdmin.checkoutcardBalance": "Card balance",
  "loyaltyAdmin.checkoutavailableCardBalance": "Available card balance",
  "loyaltyAdmin.checkoutreservedCardBalance": "Reserved card balance",
  "loyaltyAdmin.checkoutownerCardBalance": "Owner card balance",
  "loyaltyAdmin.checkoutpartCalculation": "This part card calculation",
  "loyaltyAdmin.checkoutmaximumPart": "Maximum for this part",
  "loyaltyAdmin.checkoutselectedValue": "Selected card value",
  "loyaltyAdmin.checkoutavailableAfter": "Available after this payment",
  "loyaltyAdmin.checkoutexpectedAccrual": "Expected points accrual",
  "loyaltyAdmin.checkoutpriceDiscount": "Card price discount",
  "loyaltyAdmin.checkoutgiftUsed": "Gift value used",
  "loyaltyAdmin.checkoutpromoUsed": "Promo used",
  "loyaltyAdmin.checkoutpointsAccrued": "Points accrued",
  "loyaltyAdmin.checkoutconfirmedPayment": "Confirmed card payment",
  "loyaltyAdmin.checkoutpaymentConfirmed": "Card payment confirmed.",
  "loyaltyAdmin.checkoutcardUsed": "Card value used",
  "loyaltyAdmin.checkoutrecentHistory": "Recent card balance history",
  "loyaltyAdmin.checkoutnoOperations": "No card operations yet.",
  "loyaltyAdmin.checkoutlookupCode": "Card code or QR",
  "loyaltyAdmin.checkoutreadCard": "Read card",
  "loyaltyAdmin.checkoutwithoutCard": "Continue without card",
  "loyaltyAdmin.checkoutloyaltyCard": "Loyalty card",
  "loyaltyAdmin.checkoutloyaltyCash": "Loyalty card and cash",
  "loyaltyAdmin.checkoutscanCardCheckout": "Scan card",
  "loyaltyAdmin.checkoutnone": "Do not use points",
  "loyaltyAdmin.checkoutmaximum": "Use maximum",
  "loyaltyAdmin.checkoutcustom": "Choose points",
  "loyaltyAdmin.checkoutamount": "Points to use",
  "loyaltyAdmin.checkoutmoney": "Pay for goods",
  "loyaltyAdmin.checkoutpointsDiscount": "Points discount",
  "loyaltyAdmin.checkoutprepayment": "Gift prepayment",
  "loyaltyAdmin.checkoutgiftTitle": "Gift card payment",
  "loyaltyAdmin.checkoutgiftNone": "Do not use Gift balance",
  "loyaltyAdmin.checkoutgiftMaximum": "Use maximum Gift balance",
  "loyaltyAdmin.checkoutgiftCustom": "Choose Gift amount",
  "loyaltyAdmin.checkoutpairedTitle": "Gift and Promo",
  "loyaltyAdmin.checkoutpairedNone": "Do not use card value",
  "loyaltyAdmin.checkoutpairedMaximum": "Use maximum card value",
  "loyaltyAdmin.checkoutpairedCustom": "Choose amount",
  "loyaltyAdmin.checkoutconfirmGuest": "Approve and open payment form",
  "loyaltyAdmin.checkoutfailedGuest": "The result is not confirmed. Resolve the saved payment before trying another payment.",
  "loyaltyAdmin.checkoutexpired": "Calculation expired. Choose the points amount again.",
  "loyaltyAdmin.checkoutgiftExpired": "Calculation expired. Choose the Gift amount again.",
  "loyaltyAdmin.checkoutpairedExpired": "Calculation expired. Choose the amount again.",
  "loyaltyAdmin.checkoutcashTitle": "Card payment",
  "loyaltyAdmin.checkoutcashGoods": "Cash for goods",
  "loyaltyAdmin.checkoutcashConfirm": "Record cash received",
  "loyaltyAdmin.checkoutcashFailed": "Could not confirm this payment. Resolve the saved attempt before collecting again.",
  "loyaltyAdmin.checkoutguestPending": "A saved card payment needs confirmation. Present the same card to resume. A timeout does not cancel it.",
  "loyaltyAdmin.checkoutcashPending": "A card cash payment is awaiting confirmation. Present the same card and resolve it before collecting again.",
  "loyaltyAdmin.checkoutresumeGuest": "Resume saved card payment",
  "loyaltyAdmin.checkoutresumeCash": "Resolve previous card cash payment",
  "loyaltyAdmin.checkoutcancelGuest": "Cancel unstarted approval",
  "loyaltyAdmin.checkoutcancelCash": "Cancel unstarted card approval",
  "loyaltyAdmin.checkoutzeroGuest": "Confirm payment without additional charge",
  "loyaltyAdmin.checkoutpaymentUnavailable": "Payment is unavailable.",
  "loyaltyAdmin.checkoutsavedPaymentUnreadable": "Saved payment cannot be read. Contact staff before paying again.",
  "loyaltyAdmin.checkoutrecoveryStorageUnavailable": "Payment recovery storage is unavailable. Contact staff before paying again.",
  "loyaltyAdmin.checkoutremainderUnconfirmed": "Payment remainder is not confirmed.",
  "loyaltyAdmin.checkoutcardBlocked": "This card is blocked.",
  "loyaltyAdmin.checkoutpaymentPendingResolution": "Payment is pending. Resolve this saved payment again.",
  "loyaltyAdmin.checkoutcancellationUnconfirmed": "Cancellation is not confirmed.",
  "loyaltyAdmin.checkouttipRequiresPayment": "Remove the tip to confirm without an additional payment, or use fewer points.",
  "loyaltyAdmin.checkoutcalculationChanged": "Calculation changed.",
  "loyaltyAdmin.checkoutgiftAmountCurrency": "Gift amount ({currency})",
  "loyaltyAdmin.checkoutcardAmountCurrency": "Card amount ({currency})",
  "loyaltyAdmin.checkoutworking": "Processing…",
  "loyaltyAdmin.checkouttipLabel": "Tip",
  "loyaltyAdmin.checkoutcompleteGuestCount": "Complete the guest count before checkout.",
  "loyaltyAdmin.checkoutinvalidPaymentAmount": "The calculated payment amount is invalid.",
  "loyaltyAdmin.checkoutcalculationChangedRetry": "Calculation changed. Choose the points amount again.",
  "loyaltyAdmin.checkouthistoryImportOpening": "Imported opening balance",
  "loyaltyAdmin.checkouthistoryCredit": "Value added",
  "loyaltyAdmin.checkouthistoryReserve": "Value reserved",
  "loyaltyAdmin.checkouthistoryRelease": "Reservation released",
  "loyaltyAdmin.checkouthistoryPayment": "Payment",
  "loyaltyAdmin.checkouthistoryPaymentPending": "Payment pending",
  "loyaltyAdmin.checkouthistoryPaymentCanceled": "Payment canceled",
  "loyaltyAdmin.checkouthistoryPaymentReturned": "Payment value returned",
  "loyaltyAdmin.checkouthistoryAccrualReversed": "Accrual reversed",
  "loyaltyAdmin.checkouthistoryExpired": "Value expired",
  "loyaltyAdmin.checkouthistoryOperation": "Card operation",
  "loyaltyAdmin.checkoutzeroCash": "Confirm payment without cash for goods",
  "loyaltyAdmin.checkoutchoosePart": "Select an available part of the bill to use this card.",
  "loyaltyAdmin.checkoutchooseCashPart": "Choose an amount within the remaining bill to use this card for cash.",
  "loyaltyAdmin.checkoutattached": "This card is assigned to the current visit.",
  "loyaltyAdmin.giftPresentSelectedCard": "Present the selected card to continue.",
  "loyaltyAdmin.giftDifferentCard": "This is a different card. Present the selected card.",
  "loyaltyAdmin.ownerReportTitle": "Owner report",
  "loyaltyAdmin.ownerReportNotice": "Inspect current Gift and Promo obligations and card activity for a period. The end date is included.",
  "loyaltyAdmin.ownerReportFrom": "From",
  "loyaltyAdmin.ownerReportTo": "To",
  "loyaltyAdmin.ownerReportMerchant": "Activity merchant",
  "loyaltyAdmin.ownerReportAllMerchants": "All owner merchants",
  "loyaltyAdmin.ownerReportShow": "Show report",
  "loyaltyAdmin.ownerReportInvalidPeriod": "Choose a valid report period.",
  "loyaltyAdmin.ownerReportResult": "Report result",
  "loyaltyAdmin.ownerReportAsOf": "Obligations as of",
  "loyaltyAdmin.ownerReportObligations": "Current obligations",
  "loyaltyAdmin.ownerReportActivity": "Activity in the selected period",
  "loyaltyAdmin.ownerReportEmpty": "No rows for this selection.",
  "loyaltyAdmin.ownerReportOutstanding": "Outstanding",
  "loyaltyAdmin.ownerReportAvailable": "Available",
  "loyaltyAdmin.ownerReportReserved": "Reserved",
  "loyaltyAdmin.ownerReportDebt": "Debt",
  "loyaltyAdmin.ownerReportCredited": "Credited",
  "loyaltyAdmin.ownerReportReversed": "Credit reversed",
  "loyaltyAdmin.ownerReportRedeemed": "Redeemed",
  "loyaltyAdmin.ownerReportRefunded": "Redemption refunded",
  "loyaltyAdmin.ownerReportNet": "Net movement",
  "loyaltyAdmin.ownerReportMinorUnits": "Amounts are shown in minor currency units.",
};
